var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.5 4.5L19.5 19.5","stroke":"#00121A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M19.5 4.5L4.5 19.5","stroke":"#00121A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Cross.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
